<template>
  <v-dialog v-model="dialog" persistent max-width="600" @keydown.esc="close">
    <v-card>
      <v-card-title class="title">{{title}}</v-card-title>
      <v-card-text>{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-tooltip top>
          <v-btn
            slot="activator"
            :disabled="loading"
            :loading="loading"
            flat
            @click="save"
          >
            <v-icon color="green">check</v-icon>
          </v-btn>
          <span>Yes</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn
            slot="activator"
            :disabled="loading"
            :loading="loading"
            flat
            @click="close"
          >
            <v-icon color="pink">close</v-icon>
          </v-btn>
          <span>No</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    loading: Boolean,
    title: String,
    message: String
  },
  data() {
    return {};
  },
  methods: {
    save() {
      this.$emit("save");
      console.log(this.title)
      console.log(this.dialog)
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
</style>
